import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {
    AlignmentOption,
    CreatorSection,
    defaultAlignOptions,
    defaultDirectionTypes,
    defaultMemberTypes,
    defaultProportions,
    defaultSectionTypes,
    defaultTags,
    DirectionType,
    MemberType,
    ModelTag,
    ObjectProportions,
    SectionMember,
    SectionType
} from '../../../../models/CreatorModels';
import {AddOptionsDialogComponent} from '../../custom-form-creator/add-options-dialog/add-options-dialog.component';

@Component({
    selector: 'app-options',
    templateUrl: './options.component.html',
    styleUrls: ['./options.component.scss']
})
export class OptionsComponent implements OnInit {
    @Input() sections: CreatorSection[];
    @Output() expendedSection: EventEmitter<number> = new EventEmitter<number>();
    @ViewChild('optionsContainer', {static: false}) optionsContainer: ElementRef;
    @ViewChild('fileInput', {static: false}) fileInput: ElementRef;
    expandedId: number;
    directionTypes: DirectionType[] = defaultDirectionTypes;
    memberTypes: MemberType[] = defaultMemberTypes;
    sectionTypes: SectionType[] = defaultSectionTypes;
    alignmentOptions: AlignmentOption[] = defaultAlignOptions;
    objectProportions: ObjectProportions[] = defaultProportions;
    defaultMemberTags: ModelTag[] = defaultTags;
    constructor(public dialog: MatDialog) {
    }

    ngOnInit(): void {
    }

    //#region Section Actions
    deleteSection(e, id) {
        e.stopPropagation();
        this.removeSection(id);
    }

    drop(event: CdkDragDrop<any[]>) {
        moveItemInArray(this.sections, event.previousIndex, event.currentIndex);
    }

    duplicateSection(e, id) {
        e.stopPropagation();
        let tempSection = null;
        const index = this.sections.findIndex(s => s.id === id);
        if (index !== -1) {
            tempSection = Object.assign(this.sections[index]);
            tempSection.id = this.sections.length + 1;
        }
        this.sections.push(tempSection);
    }

    showSection(e, section: CreatorSection) {
        e.stopPropagation();
        section.displayed = !section.displayed;
    }

    handleOpenSection(section: any) {
        if(section) {
            this.expandedId = section.id;
            this.expendedSection.emit(section.id);
        }
    }

    handleCloseSection(section: any) {
        if (section && this.expandedId === section.id) {
            this.expendedSection.emit(0);
        }
    }

    removeSection(id) {
        const index = this.sections.findIndex(s => s.id === id);
        if (index !== -1) {
            this.sections.splice(index, 1);
        }

        for (const section of this.sections) {
            if (section.id !== 1 && section.id > id) {
                section.id--;
            }
        }
    }

    //#endregion

    //#region Member Actions
    addMember(id) {
        const section = this.sections.find(s => s.id === id);
        section.members.push({
            id: section.members.length + 1,
            type: this.memberTypes[0],
            align: this.alignmentOptions[0],
            proportion: this.objectProportions[3],
            title: `Tίτλος επιλογής ${section.members.length + 1}`,
            value: null,
            mandatory: false,
            options: [],
            tag: null,
            isQuestion: false
        });
    }

    memberCanEdit(member: SectionMember) {
        if (member.type.type !== 'text' && member.type.type !== 'toggle' && member.type.type !== 'image' && member.type.type !== 'label') {
            return true;
        } else {
            return false;
        }
    }

    memberHasActions(member: SectionMember) {
        if (member.type.type !== 'text' && member.type.type !== 'toggle') {
            return true;
        } else {
            return false;
        }
    }

    removeMember(e: any, sectionId, memberId) {
        e.stopPropagation();
        const section = this.sections.find(s => s.id === sectionId);
        const index = section.members.findIndex(m => m.id === memberId);

        if (index !== -1) {
            section.members.splice(index, 1);
        }

        for (const member of section.members) {
            if (member.id !== 1 && member.id > memberId) {
                member.id--;
            }
        }
    }

    //#region Member Movement
    // Checks if member is first in member list
    isMemberFirst(section: any, memberId: number): boolean {
        const index = section.members.findIndex(member => member.id === memberId);
        if (index !== -1) {
            return index === 0;
        }
    }

    // Checks if member is last in member list
    isMemberLast(section: any, memberId: number): boolean {
        const index = section.members.findIndex(member => member.id === memberId);
        if (index !== -1) {
            return index === section.members.length - 1;
        }
    }

    moveMemberUp(e: any, section: any, memberId: number): void {
        e.stopPropagation();
        const index = section.members.findIndex(member => member.id === memberId);
        let temp = null;
        if (index !== -1) {
            temp = section.members[index - 1];
            section.members[index - 1] = section.members[index];
            section.members[index] = temp;
        }
    }

    moveMemberDown(e: any, section: any, memberId: number): void {
        e.stopPropagation();
        const index = section.members.findIndex(member => member.id === memberId);
        let temp = null;
        if (index !== -1) {
            temp = section.members[index + 1];
            section.members[index + 1] = section.members[index];
            section.members[index] = temp;
        }
    }

    //#endregion
    //#endregion

    addOption(sectionId: number, memberId) {
        const section = this.sections.find(s => s.id === sectionId);
        const member = section.members.find(m => m.id === memberId);

        const optionsDialog = this.dialog.open(AddOptionsDialogComponent, {
            width: '600px',
            height: '550px',
            data: {
                options: member.options
            }
        });

        optionsDialog.afterClosed().subscribe((result: any[]) => {
        });
    }

    addLabelValue(member: SectionMember) {
        const optionsDialog = this.dialog.open(AddOptionsDialogComponent, {
            width: '900px',
            height: '850px',
            hasBackdrop: true,
            disableClose: true,
            data: {
                type: 'label',
                value: member.value
            }
        });

        optionsDialog.afterClosed().subscribe((result: any[]) => {
            member.value = result;
        });
    }

    onFileInput($event: any, sectionId, memberId) {
        console.log($event);
        // const file: File = this.fileInput.nativeElement.files[0];
        const file: File = $event.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
            const image = new Image();

            if (typeof e.target.result === 'string') {
                image.src = e.target.result;
            }

            image.onload = (i) => {
                const height = image.height;
                const width = image.width;
                console.log(file.type);
                if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
                    alert(`Μη αποδεκτή μορφή εικόνας`);
                    return false;
                }
                if (height > 1000 || width > 1000) {
                    alert(`Η φωτογραφία θα πρέπει να έχει μέγιστες διαστάσεις 300px ύψος και 300px πλάτος`);
                    return false;
                } else {
                    const section = this.sections.find(s => s.id === sectionId);
                    const index = section.members.findIndex(m => m.id === memberId);
                    if (index !== -1) {
                        console.log(index);
                        section.members[index].options.push({id: 1, label: '', value: reader.result});
                        console.log(section.members[index]);
                    }
                }
            };
        };
        reader.readAsDataURL(file);
    }

    canSetTag(type: MemberType) {
        return type.type === 'text';
    }
}
